import React from 'react'
import { Spin } from 'antd'

const LoadingSpinner = ({ size = 'large' }) => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: '#f5f5f5'
    }}>
      <Spin size={size} />
    </div>
  )
}

export default LoadingSpinner
